import { useLocation, useNavigate } from "react-router-dom";
import styles from "./OrganisationHomepage.module.scss";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useEffect, useState } from "react";
import { Button } from "@mui/material";
import { VictoryIcon } from "../components/Icons/Victory";
import { useTranslation } from "../i18n";

interface LocationState {
  from?: string;
}

export const OrganisationHomepage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const from = (location.state as LocationState)?.from;
  const [dialogOpen, setDialogOpen] = useState<boolean>(
    from?.includes("register") ? true : false,
  );

  useEffect(() => {
    const root = document.getElementById("root");
    if (root) {
      if (dialogOpen) {
        root.classList.add("dialog-blur");
      } else {
        root.classList.remove("dialog-blur");
      }
    }
    return () => {
      if (root) {
        root.classList.remove("dialog-blur");
      }
    };
  }, [dialogOpen]);

  return (
    <div className={styles.organisationHp}>
      <Dialog
        open={dialogOpen}
        disableEscapeKeyDown
        onClose={() => {}}
        slotProps={{
          backdrop: {
            onClick: () => {},
          },
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xs"
        className={styles.dialog}
      >
        <DialogTitle id="alert-dialog-title" className={styles.title}>
          <VictoryIcon />
          {t("orgHome.profileReadyTitle")}
        </DialogTitle>
        <DialogContent className={styles.content}>
          <DialogContentText id="alert-dialog-description">
            {t("orgHome.profileReadyText")}
          </DialogContentText>
        </DialogContent>
        <DialogActions className={styles.actions}>
          <Button
            variant="contained"
            onClick={() => {
              navigate("/organisation/events", {
                state: { from: "organisation-homepage" },
              });
              setDialogOpen(false);
            }}
          >
            {t("orgHome.enter")}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

